module.exports = "<!-- <h1> {{ fornitore }} </h1> -->\r\n<!-- <h2> Nome Fornitore: {{fornitore.NomeFornitore}} </h2> -->\r\n<div class=\"row\">\r\n        \r\n    <div class=\"col-md-12 category-image view hm-zoom\">\r\n        <a [routerLink]=\"['/ListaOfferte',comodity,fornitore.Id_fornitore]\"   >\r\n            <img class=\"tab category-image-responsive img-fluid\" [src]=\"fornitore.LinkLogo\"  [alt]=\"fornitore.NomeFornitore\">\r\n        </a>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/fornitori/fornitori.component.html
// module id = ./src/app/fornitori/fornitori.component.html
// module chunks = main